module.exports = __webpack_public_path__ + "assets/img/toc-game-icon.502f5c89.svg";